<div [hidden]="selectedMerchant != undefined && !toggleTableOn">
  <div style="margin-bottom: 10px">
    <input
      type="button"
      value="View other businesses"
      class="button_primary button_var_2"
      (click)="toggleTableOn = !toggleTableOn"
    />
  </div>
  <div>
    <app-filterable-table
      #merchantTable
      [tableView]="merchantTableView"
      [options]="merchantTableOptions"
      (selectedRecord)="handle_selectedMerchant($event)"
    ></app-filterable-table>
  </div>
</div>

@if (selectedMerchant != undefined) {
  <div>
    <app-merchant-business-view></app-merchant-business-view>
  </div>
}
